import { ClusterDetails, ClusterDetailsState, GenerateClusterNameResponsePayload } from 'tabs/topQuestions/types/InternalTypes'
import { PendingRequest, RequestStatus } from 'tabs/topQuestions/types/GenericTypes'

import { TopQuestionsSlice } from 'tabs/topQuestions/lib/top_questions/topQuestionsConstnats'

export const selectTopQuestionsRequest = (store: any): RequestStatus => {
  const topQuestionsState: TopQuestionsSlice = store.topQuestions
  return topQuestionsState.fetchTopQuestionsRequestStatus
}
export const selectClusters = (store: any): ClusterDetailsState => {
  const topQuestionsState: TopQuestionsSlice = store.topQuestions
  return topQuestionsState.clusters
}

export const findHoveredClusterId = (store: any): string | undefined => {
  const topQuestionsState: TopQuestionsSlice = store.topQuestions
  const allClusters = Object.values(topQuestionsState.clusters)
  const hoveredCluster = allClusters.find(c => c.hovered)
  return hoveredCluster?.clusterUniqueId
}

export const displayedClusters = (store: any): ClusterDetails[] => {
  const topQuestionsState: TopQuestionsSlice = store.topQuestions
  return Object.values(topQuestionsState.clusters).filter(c => c.isDisplayed)
}

export const selectClusterDisplayedStatus = (clusterId: string) => {
  return (store: any): boolean => {
    const topQuestionsState: TopQuestionsSlice = store.topQuestions
    const cluster = topQuestionsState.clusters[clusterId]
    if (cluster != null) {
      return cluster.isDisplayed
    } else {
      console.error('Cluster not found ' + clusterId)
      return false
    }
  }
}
export const selectClusterDetails = (store: any): ClusterDetails[] => {
  const topQuestionsState: TopQuestionsSlice = store.topQuestions
  const { clusters } = topQuestionsState
  return Object.values(clusters)
}

export const selectClustersNameMap = (store: any): Record<string, string> => {
  const topQuestionsState: TopQuestionsSlice = store.topQuestions
  const { clusters } = topQuestionsState
  return Object.entries(clusters)
    .map(([key, value]) => {
      return {
        [key]: value.clusterName,
      }
    })
    .reduce((val, acc) => ({ ...val, ...acc }), {})
}

export const selectGenerateClusterNameRequest = (clusterId: string) => {
  return (store: any): PendingRequest<GenerateClusterNameResponsePayload> | undefined => {
    const topQuestionsState: TopQuestionsSlice = store.topQuestions
    return topQuestionsState.generateNameRequest[clusterId]
  }
}

export const selectClusterColorsMap = (store: any): Record<string, number[]> | undefined => {
  const topQuestionsState: TopQuestionsSlice = store.topQuestions
  return topQuestionsState.clustersColorMap
}
